import * as THREE from 'three';
import { NAV } from '../config.js';
import { PLANS } from '../data/plans/index.js';
import { buildHouse } from './house/buildHouse.js';
import { applyTransform } from './transform.js';
import { createModelSource } from './sceneSource.js';

/**
 * 設計データから組み立てる CG の物件（スキャンではなく、間取りとパースを基に作った部屋）。
 * ダウンロードは無いので進捗はすぐ 1 になる。
 */
export async function loadHouse(scene, property, { onProgress } = {}) {
  const plan = PLANS[property.plan];
  if (!plan) throw new Error(`設計データ ${property.plan} がありません`);
  onProgress?.(0.2);

  // 設計データから起こした CG は面が少ないので、影を落として立体的に見せる
  const root = buildHouse({ ...plan, shadows: true });
  applyTransform(root, property.transform);
  scene.add(root);

  /*
   * 当たり判定マップは建物全体を覆う大きさにする（スキャンと違い、どこにでも行ける）。
   *
   * 基準点は最初の視点（＝必ず部屋の中）に置く。
   * 建物の中心にすると壁の中に落ちることがあり、そこから一番低い面を探すと
   * 壁の上や屋根を「床」と誤認して、屋根の上を歩けるマップができてしまう。
   */
  const box = new THREE.Box3().setFromObject(root);
  const center = box.getCenter(new THREE.Vector3());
  const first = property.viewpoints[0]?.position;
  const navOrigin = new THREE.Vector3(first?.[0] ?? center.x, box.min.y, first?.[2] ?? center.z);
  // 基準点が端に寄っても建物全体が入るよう、対角の長さを半径にする
  const navRadius = Math.hypot(box.max.x - box.min.x, box.max.z - box.min.z) + 1;
  onProgress?.(1);
  const source = createModelSource(root, { navOrigin, navRadius, sampleDensity: NAV.planSampleDensity });
  // 部屋の広さを出すのに設計データが要る（src/viewer/house/roomArea.js）
  return { ...source, plan };
}
